import i18n from '../../../../locales/index'
import SideMenu from './side-menu.vue'
export default SideMenu
